import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogKeeper } from "@/shared/models/CatalogKeeper";
import { ColDef, ICellRendererParams } from "ag-grid-community";

type Props = {
	setSelectedRowData: (keeper: CatalogKeeper) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "KeeperCode",
			headerName: "Code",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
			minWidth: 150,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogKeeper,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "keepersContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	const getMenuOptions = (data: CatalogKeeper) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Keeper",
				key: "new_keeper",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);

		if (data) {
			options = options.concat([
				{
					name: "Edit Keeper",
					key: "edit_keeper",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Keeper",
					key: "delete_keeper",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { columnDefs, getMenuOptions };
};
